var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 300h-400v179.996h400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6133-22.383-50-50-50h-300c-27.6172 0-50 22.3867-50 50v380c0 27.613 22.3828 50 50 50h240l110-110z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360 80h-240v160h240z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#74bd71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#6aad68"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.793v96.793z",
    fill: "#6aad68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.387-50 50v60h110z",
    fill: "#b9deb8"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.254 417.699h12.305v-40.867c0-5.305-1.465-9.566-4.395-12.789s-6.758-4.832-11.504-4.832c-3.437 0-6.504 1.008-9.2069 3.031-2.7187 2.02-4.7968 5.113-6.2617 9.274l9.0426 6.851v-.176c.059-.027.352-.671.879-1.929.528-1.262 1.192-2.395 2-3.41.813-1.004 1.684-1.512 2.617-1.512 1.379 0 2.473.57 3.293 1.711.821 1.144 1.231 2.668 1.231 4.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.688 407.328v-14.765h4.835c2.082 0 3.86.746 5.34 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.84 4.16-2.5 5.449-1.68 1.289-4.043 1.934-7.129 1.934zm-12.176 10.371h19.734c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.875-7.156 4.875-12.199 0-3.308-.801-6.453-2.39-9.422-1.594-2.976-4.004-5.195-7.227-6.66-3.227-1.465-5.981-2.226-8.266-2.285l-7.207-.176v-22.324h-12.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.063 405.176-8.258-7.735c-1.731 2.989-3.867 5.219-6.418 6.7-2.547 1.48-5.215 2.222-7.996 2.222-4.512 0-8.43-1.715-11.75-5.14-3.34-3.43-5-7.473-5-12.129 0-4.953 1.66-9.153 5-12.59 3.32-3.445 7.324-5.164 12.011-5.164 2.547 0 5 .64 7.364 1.93 2.351 1.293 4.257 3.707 5.683 7.253h-13.664v11.25h26.633v-7.472c0-3.836-1.316-7.961-3.953-12.367-2.641-4.414-6.106-7.637-10.422-9.668-4.297-2.039-8.652-3.055-13.047-3.055-7.969 0-14.687 2.883-20.176 8.656-5.468 5.77-8.215 12.906-8.215 21.403 0 8.054 2.825 14.941 8.469 20.652 5.625 5.715 12.422 8.57 20.364 8.57 10.132 0 17.925-4.441 23.375-13.316"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m360 240h-240v-160h240zm-30-30v-100h-180v100z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m380 63.3008h-280v30h30l40.215 48.2582c2.578 3.089 6.289 5.019 10.305 5.343 4.011.328 7.996-.972 11.035-3.609l30.34-26.273c2.089-1.817 4.851-2.672 7.609-2.379 2.762.297 5.269 1.722 6.934 3.945l40.386 53.852c2.981 3.964 7.715 6.207 12.668 5.984 4.949-.219 9.473-2.863 12.078-7.074l48.43-78.0472h30z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m190 180c0 11.039 8.953 20 20 20s20-8.961 20-20-8.953-20-20-20-20 8.961-20 20",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.460262db0220aecc5ca0c5007096f0f0.svg";
export { ForwardRef as ReactComponent };